import React, { ReactNode } from "react"

import { IconSize } from "@izettle/otto"
import { IconMetadata, IllustrationMetadata } from "@izettle/react"

export type IconMedium = IconMetadata<IconSize.Medium>
export type IconLarge = IconMetadata<IconSize.Large>

export enum TypeOfPurposes {
  Mixed = "mixed",
  Loa = "loa",
}

export enum SellerType {
  New = "new",
  Existing = "existing",
}

export type PurposesContent = {
  [key: string]: {
    [key: string]: {
      name: string
      text: string
      icon: IconMedium
    }
  }
}

export type Purpose = {
  documentPurposeType: string
  status: string
}

export type DocumentPurposes = {
  documentPurposeItems: Purpose[]
  isSellerVerificationTaskRejected: boolean
  isExistingSeller: boolean
}

export type File = {
  name: string
  type: string
}

export type SelectFilesProps = (
  selectedFiles: any,
  selectedPurpose: string | undefined,
  selectedType: string | undefined,
  selectedDescription?: string | undefined,
  redirect?: string | undefined,
  selectedIsdoubleSided?: boolean | undefined,
) => void

export type LoaContract = {
  email: string
  employeeFirstName: string
  employeeLastName: string
  employeePosition: string
  firstName: string
  lastName: string
  phoneNumber: string
  position: string
}

export type LoaFormSteps = {
  employee: boolean
  authorizer: boolean
  submit: boolean
}

export type FormField = {
  field: keyof LoaContract
  label: string
  mask?: string
  help?: ReactNode
  ref: React.RefObject<HTMLInputElement>
}

export type ErrorContent = {
  [key: string]: {
    title: string
    generalErrorText: string
    additionalErrorText?: string | JSX.Element
    illustration: IllustrationMetadata
    buttonText: string
  }
}

export type Loading = {
  kind: "loading"
}

export type LoadingError = {
  kind: "loading-error"
}

export type TaskNew = {
  kind: "new"
}

export type TaskCompleted = {
  kind: "completed"
}

export type TaskRejected = {
  kind: "rejected"
}

export type TaskDone = {
  kind: "done"
}

export type PurposesState =
  | Loading
  | LoadingError
  | TaskNew
  | TaskCompleted
  | TaskRejected
  | TaskDone

export type ViewedPageEventPayload = {
  [key: string]: any
}
